export default __webpack_public_path__ + "static/media/aurelian_logo.dece2789.svg";